import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { ReportShowClick } from '../../../config/Validate';
import { degreeList, SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { ACCOUNTLEDGER, DEGREEDETAILSREPORT, DOWNLOADACCOUNTLEDGER, DOWNLOADDEGREEDETAILS, GETACCOUNTS } from '../../../config/ApiConstant';
import { AccountLedgerReportListColumns, DegreeDetailsListColumns } from '../../../appconfig/DatatableSetting';

import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { amountFormate, downloadData, exportData } from '../../../appconfig/AppHelper';
import { amountCommonTemplate, amountTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const AccountLedgerReport = () => {
    document.title = 'Account Ledger | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [selectedAccount, setSelectedAccount] = useState<any>(null);
    const [accountLedgerList, setAccountLedgerList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [exportLoader, setExportLoader] = useState<boolean>(false);

    const [accountOptions, setAccountOptions] = useState<any>([]);
    const [credit, setCredit] = useState<any>();
    const [debit, setDebit] = useState<any>();
    const [creditPlus, setCreditPlus] = useState<any>();
    const [showButton, setShowButton] = useState<boolean>(false);

    // Date Object
    const storedDates = localStorage.getItem('accountledge_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    useEffect(() => {
        getAllAccounts();
    }, []);

    // Get all accounts
    const getAllAccounts = async () => {
        try {
            const response = await getAllDetailsDirect(GETACCOUNTS);

            if (response) {
                let accOption: any = [];
                if (response?.List?.name !== 'User') {
                    response.List.map((option: any) => {
                        accOption.push({ name: option.AccName, code: option.SrNo });
                    });
                }
                setAccountOptions(accOption);
                setCreditPlus(response?.creditPlus);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });
        if (start && end) {
            localStorage.setItem(
                'accountledge_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <div>
                    <Dropdown
                        value={selectedAccount}
                        name="application"
                        options={accountOptions}
                        filter
                        optionLabel="name"
                        placeholder="Select Account Name"
                        onChange={(e) => setSelectedAccount(e.value)}
                        className={errors['application'] ? 'p-invalid mr-2' : 'mr-2'}
                    />
                    <small className="p-invalid-txt">{errors['application']}</small>
                </div>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button label="Show" onClick={() => getAccountLedgerList()} loading={showLoading} className="ml-2"></Button>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-file-export" label="Export" onClick={() => exportCSV()} className="p-button-success" loading={exportLoader} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-download" label="Download" onClick={() => downloadAllData()} className="mx-2" loading={loading} disabled={showButton ? false : true}></Button>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //downloadDAta
    const downloadAllData = async () => {
        try {
            setLoading(true);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            // Request Data
            const requestData = {
                from_date: startDate,
                to_date: endDate,
                AccSrNo: selectedAccount?.code
            };

            const response = await downloadData(DOWNLOADACCOUNTLEDGER, 'Account_Ledger_Report', requestData);
            if (response === true) {
                setLoading(false);
            } else if (response === false) {
                setLoading(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //export CSv
    const exportCSV = async () => {
        setExportLoader(true);

        let res = await exportData('Account_Ledger_Report');
        if (res === true) {
            setExportLoader(false);
        } else {
            setExportLoader(false);
        }
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // getAccountLedgerListList
    const getAccountLedgerList = async () => {
        try {
            const { errors, isError } = ReportShowClick(selectedAccount);
            setErrors(errors);
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);
                let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
                let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
                // Request Data
                const requestData = {
                    from_date: startDate,
                    to_date: endDate,
                    AccSrNo: selectedAccount?.code
                };

                const response = await postAllData(ACCOUNTLEDGER, requestData);

                if (response) {
                    setPageLoad(true);
                    setShowLoading(false);
                    setAccountLedgerList(response?.data);
                    setCredit(response?.credit);
                    setDebit(response?.debit);
                    setShowButton(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                setAccountLedgerList([]);
                setShowLoading(false);
                setShowButton(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const closingTemplate = (rowData: any) => {
        // let closingBal = 0;

        // {
        //     creditPlus ? (
        //         <>{!window.cn(rowData?.Debit) && parseInt(rowData?.Debit) !== 0 ? (closingBal = closingBal - parseInt(rowData?.Debit)) : (closingBal = closingBal + parseInt(rowData?.Credit))}</>
        //     ) : (
        //         <>{!window.cn(rowData?.Debit) && parseInt(rowData?.Debit) !== 0 ? (closingBal = closingBal + parseInt(rowData?.Debit)) : (closingBal = closingBal - parseInt(rowData?.Credit))}</>
        //     );
        // }

        return <>{rowData?.closing}</>;
    };

    let totalClosing = Number(debit) - Number(credit);

    const closingBalance = !window.cn(totalClosing) ? Math.abs(totalClosing) : '';

    return (
        <>
            <AppBreadcrumb currentMenu={'Financial Reports'} pageName={'Account Ledger'} pageTitle={'Account Ledger'} goToPage={true} />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={accountLedgerList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {AccountLedgerReportListColumns.map((col: any, i: any) => {
                                        if (col.field === 'CurrDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'Credit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} footer={!window.cn(credit) && credit} />;
                                        } else if (col.field === 'Debit') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountCommonTemplate} footer={!window.cn(debit) && debit} />;
                                        } else if (col.field === 'closing') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={closingTemplate} footer={!window.cn(closingBalance) && closingBalance} />;
                                        } else if (col.field === 'Message') {
                                            return <Column key={col.field} field={col.field} header={col.header}  />;
                                        } else if (col.field === 'sr_no') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '4rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AccountLedgerReportListColumns.map((col: any, i: any) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
